export const Diamond = ({ isFilled }: { isFilled?: boolean }) => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill={isFilled ? 'black' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 21.575L0.309125 11L8 0.425046L15.6909 11L8 21.575Z"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  );
};
